import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _slicedToArray from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _createForOfIteratorHelper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _defineProperty from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectSpread from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";

/*! Provides core utilities for the working with both versions of the ESRI JSAPI.
 *
 * @ai360/core v35.6.1 (https://bitbucket.org/agvanceskyteam/ai360.client.core.git)
 * SSI DO NOT COPY!!!
 */
import { G as e, a as t } from "../enums.js";
import { c as r, J as o, o as i, S as l, a, b as s } from "../symbols.js";
import { G as n } from "../geometry/utils.js";
import m from "@arcgis/core/Graphic";
import c from "@arcgis/core/geometry/Geometry";
import { ah as p, as as S, at as d, au as u, av as y } from "../api/rec.js";
import "uuid";
import "@arcgis/core/geometry/SpatialReference";
import "@arcgis/core/tasks/Locator";
import * as f from "@arcgis/core/geometry/support/webMercatorUtils";
import "@arcgis/core/geometry/support/jsonUtils";
import "@arcgis/core/geometry/projection";
import "@terraformer/arcgis";
import { n as b } from "../index.js";
import "@arcgis/core/geometry/Polygon";
import "lodash";
import g from "@arcgis/core/layers/GraphicsLayer";
import h from "@arcgis/core/layers/FeatureLayer";
import x from "@arcgis/core/layers/TileLayer";
import N from "@arcgis/core/layers/VectorTileLayer";
import O from "@arcgis/core/layers/MapImageLayer";
import F from "@arcgis/core/layers/support/LabelClass";
import J from "@arcgis/core/geometry/Extent";
import C from "@arcgis/core/renderers/UniqueValueRenderer";
import * as L from "@arcgis/core/geometry/geometryEngine";
import * as w from "@arcgis/core/geometry/support/geodesicUtils";

var E = _objectSpread(_objectSpread({}, r), {}, {
  symbols: _objectSpread(_objectSpread({}, r.symbols), {}, {
    dgg: {
      mgrsCell: o.createSimpleFillSymbolJSON([255, 255, 255, 25], [0, 255, 255, 180], 2),
      crosshair: o.createSimpleLineSymbolJSON([0, 255, 255, 85], 1),
      userDefined: o.createSimpleFillSymbolJSON([255, 255, 255, 50], [64, 255, 255, 180], 2)
    },
    fields: {
      background: o.createSimpleFillSymbolJSON([171, 171, 171, 75], [130, 130, 130, 180], 3),
      filteredOut: o.createSimpleFillSymbolJSON([171, 171, 171, 166], [130, 130, 130, 255], 2),
      labels: {
        lineHeight: 12,
        placementPrecision: 60,
        text: o.createTextSymbolJSON([255, 255, 255, 255], "Arial", 9, 0, 0, "normal", "normal")
      },
      normal: o.createSimpleFillSymbolJSON([29, 170, 236, 166], [0, 0, 172, 255], 2),
      selected: o.createSimpleFillSymbolJSON([226, 104, 22, 102], [255, 255, 255, 255], 3),
      selectionBox: o.createSimpleFillSymbolJSON([226, 104, 22, 102], [255, 255, 255, 255], 3),
      transparent: o.createSimpleFillSymbolJSON([0, 0, 0, 0], [255, 255, 255, 230], 2.5),
      withData: o.createSimpleFillSymbolJSON([226, 104, 22], [255, 140, 0], 3, "esriSLSSolid", "esriSFSBackwardDiagonal"),
      withDataImage: o.createPictureFillSymbolJSON(i, !0, "image/png", 10, 10, .7, .7, [255, 140, 0], 3, "esriSLSSolid")
    },
    filterDataPoints: {
      filteredColor: [255, 255, 0],
      size: 5,
      unfilteredColor: [50, 250, 0]
    },
    importFieldBoundary: {
      normal: o.createSimpleFillSymbolJSON([29, 170, 236, 166], [255, 255, 255, 255], 3),
      editing: o.createSimpleFillSymbolJSON([226, 104, 22, 102], [255, 255, 255, 255], 3),
      conflicted: o.createSimpleFillSymbolJSON([255, 255, 0, 102], [255, 255, 0, 255], 3),
      duplicateBoundaryText: o.createTextSymbolJSON([255, 255, 0, 255], "Arial", 10, 0, 14, "italic", "normal"),
      selected: o.createSimpleFillSymbolJSON([0, 0, 0, 0], [255, 255, 255, 235], 6)
    },
    importDataConvexHull: o.createSimpleFillSymbolJSON([29, 170, 239, 150], [29, 170, 239, 200], 2, "esriSLSSolid", "esriSFSDiagonalCross"),
    importDataPoints: {
      matchedColor: [50, 250, 0],
      removedColor: [0, 0, 0, 0],
      selectedColor: [0, 255, 255],
      size: 5,
      unmatchedColor: [255, 0, 0]
    },
    nonFieldFeatures: {
      point: o.createSimpleMarkerSymbolJSON([191, 255, 0, 102], 9, "esriSMSCircle", 0, 0, [255, 255, 255], 1),
      polygon: o.createSimpleFillSymbolJSON([191, 255, 0, 102], [255, 255, 255], 3),
      polyline: o.createSimpleLineSymbolJSON([255, 200, 0], 3),
      label: o.createTextSymbolJSON([0, 0, 0, 255], "Arial", 9, 0, 0, "normal", "bolder", [255, 255, 255, 200], 1),
      pointLabel: o.createTextSymbolJSON([0, 0, 0, 255], "Arial", 9, 6, 0, "normal", "bolder", [255, 255, 255, 200], 1, "left"),
      selected: {
        point: o.createSimpleMarkerSymbolJSON([255, 200, 0, 102], 9, "esriSMSCircle", 0, 0, [60, 60, 0], 1),
        polygon: o.createSimpleFillSymbolJSON([255, 200, 0, 102], [60, 60, 0], 3),
        polyline: o.createSimpleLineSymbolJSON([255, 200, 0], 3)
      },
      highlighted: {
        point: o.createSimpleMarkerSymbolJSON([255, 200, 0, 102], 9, "esriSMSCircle", 0, 0, [60, 60, 0], 1),
        polygon: o.createSimpleFillSymbolJSON([255, 200, 0, 102], [60, 60, 0], 3),
        polyline: o.createSimpleLineSymbolJSON([255, 200, 0], 3)
      },
      panel: {
        swatch: o.createSimpleFillSymbolJSON([191, 255, 0, 102], [255, 255, 255], 3)
      }
    },
    sampleSites: {
      default: o.createSimpleMarkerSymbolJSON([73, 142, 226], 9, "esriSMSCircle", 0, 0, [255, 255, 255]),
      label: {
        value: o.createLabelJSON(o.createTextSymbolJSON()),
        text: o.createTextSymbolJSON([255, 255, 255], "Arial", 10, 10, 10, "normal", "bold", [0, 0, 0])
      },
      selected: o.createSimpleMarkerSymbolJSON([143, 166, 26], 9, "esriSMSCircle", 0, 0, [255, 255, 255]),
      unmatched: o.createSimpleMarkerSymbolJSON([255, 0, 0], 9, "esriSMSCircle", 0, 0, [255, 255, 255]),
      untraced: {
        default: o.createSimpleMarkerSymbolJSON([73, 142, 226], 9, "esriSMSCircle", 0, 0, [0, 0, 0]),
        selected: o.createSimpleMarkerSymbolJSON([143, 166, 26], 9, "esriSMSCircle", 0, 0, [0, 0, 0])
      }
    }
  }),
  cadastral: {
    definitions: [{
      name: "Counties",
      fetchFromApi: "fetchSpatialCounties",
      toShape: function toShape(e) {
        return e.shape;
      },
      toGraphicAttributes: function toGraphicAttributes(e) {
        return {
          key: "county_".concat(e.state, "_").concat(e.name),
          name: e.name.toUpperCase()
        };
      },
      items: [{
        geometry: {
          symbol: o.createSimpleFillSymbolJSON([0, 0, 0, 0], [156, 156, 156, 255], 2),
          minScale: 25e5
        },
        text: {
          symbol: o.createTextSymbolJSON([104, 104, 104, 255], "Montserrat", 10, 0, 0, "normal", "bold", [240, 240, 240, 255], 1.25),
          minScale: 15e5,
          maxScale: 24e3,
          textExtractor: function textExtractor(e) {
            return e.name;
          }
        }
      }, {
        geometry: {
          symbol: o.createSimpleFillSymbolJSON([0, 0, 0, 0], [0, 0, 0, 255], 1, "esriSLSLongDashDot"),
          minScale: 25e5
        }
      }]
    }, {
      name: "Townships",
      fetchFromApi: "fetchSpatialTownships",
      toShape: function toShape(e) {
        return e.shape;
      },
      toGraphicAttributes: function toGraphicAttributes(e) {
        return {
          key: "township_".concat(e.lndKey),
          township: e.township.toUpperCase(),
          range: e.range.toUpperCase()
        };
      },
      items: [{
        geometry: {
          symbol: o.createSimpleFillSymbolJSON([0, 0, 0, 0], [130, 130, 130, 255], 3),
          minScale: 75e4
        },
        text: {
          symbol: o.createTextSymbolJSON([104, 104, 104, 255], "Montserrat", 9, 0, 0, "normal", "bold", [240, 240, 240, 255], 1.25),
          minScale: 25e4,
          maxScale: 5e4,
          textExtractor: function textExtractor(e) {
            return "T".concat(e.township);
          }
        }
      }, {
        text: {
          symbol: o.createTextSymbolJSON([104, 104, 104, 255], "Montserrat", 9, 0, -10, "normal", "bold", [240, 240, 240, 255], 1.25),
          minScale: 25e4,
          maxScale: 5e4,
          textExtractor: function textExtractor(e) {
            return "R".concat(e.range);
          }
        }
      }]
    }, {
      name: "Sections",
      fetchFromApi: "fetchSpatialSections",
      toShape: function toShape(e) {
        return e.shape;
      },
      toGraphicAttributes: function toGraphicAttributes(e) {
        return {
          key: "section_".concat(e.lndKey, "_").concat(e.section),
          township: e.township.toUpperCase(),
          range: e.range.toUpperCase(),
          section: e.section.toUpperCase()
        };
      },
      items: [{
        geometry: {
          symbol: o.createSimpleFillSymbolJSON([0, 0, 0, 0], [156, 156, 156, 255], 2),
          minScale: 5e5
        },
        text: {
          symbol: o.createTextSymbolJSON([104, 104, 104, 255], "Montserrat", 8, 0, 0, "normal", "bold", [240, 240, 240, 255], 1.25),
          minScale: 5e4,
          textExtractor: function textExtractor(e) {
            return "T".concat(e.township);
          }
        }
      }, {
        text: {
          symbol: o.createTextSymbolJSON([104, 104, 104, 255], "Montserrat", 8, 0, -9, "normal", "bold", [240, 240, 240, 255], 1.25),
          minScale: 5e4,
          textExtractor: function textExtractor(e) {
            return "R".concat(e.range);
          }
        }
      }, {
        text: {
          symbol: o.createTextSymbolJSON([104, 104, 104, 255], "Montserrat", 8, 0, -18, "normal", "bold", [240, 240, 240, 255], 1.25),
          minScale: 5e4,
          textExtractor: function textExtractor(e) {
            return e.section;
          }
        }
      }]
    }]
  }
});

var M = {
  create: function create(e, t, r, o) {
    return e instanceof c ? m.fromJSON({
      geometry: e.toJSON(),
      symbol: t.toJSON(),
      attributes: r,
      popupTemplate: o ? o.toJSON() : null
    }) : Object.values(e).filter(function (e) {
      return !!e;
    }).some(function (e) {
      return e.declaredClass;
    }) ? new m(e) : m.fromJSON(e);
  }
},
    G = new Map(),
    _getLabelScreenExtent = function _getLabelScreenExtent(e, t, r) {
  var o = _getScreenPoint(e.extent, e.width, e.height, t.geometry),
      i = 4 * r / 3,
      l = t.symbol;

  var a, s;

  if (G.has(l.text)) {
    var _e = G.get(l.text);

    a = _e.halfWidth, s = _e.halfHeight;
  } else a = l.text.length * i * .7 / 2, s = i / 2, G.set(l.text, {
    halfHeight: s,
    halfWidth: a
  });

  return o.x += l.xoffset, o.y += l.yoffset, new J({
    xmin: o.x - a,
    ymin: o.y - s,
    xmax: o.x + a,
    ymax: o.y + s,
    spatialReference: e.spatialReference
  });
},
    _getRgbaFromColorArray = function _getRgbaFromColorArray(e) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
  return "rgba(".concat(e[0], ",").concat(e[1], ",").concat(e[2], ",").concat(t ? 255 : e[3] / 255, ")");
},
    _getColorArray = function _getColorArray(e) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
  return [e[0], e[1], e[2], t ? 255 : e[3] / 255];
},
    _getScreenPoint = function _getScreenPoint(e, t, r, o) {
  var i = t / (e.xmax - e.xmin),
      l = r / (e.ymax - e.ymin),
      a = (o.x - e.xmin) * i,
      s = (e.ymax - o.y) * l;
  return {
    x: Math.round(a),
    y: Math.round(s)
  };
},
    _updateFilterPointAttributes = function _updateFilterPointAttributes(e, t) {
  var r = [];
  Object.keys(t).forEach(function (e) {
    t[e] && r.push(e);
  }), e.Filtered = r.some(function (t) {
    return e.matchedFilterSet.has(t);
  });
},
    _updatePointDataAttributes = function _updatePointDataAttributes(e, t, r, o) {
  var i = 0 === e.matchedFieldGuidSet.size || t.some(function (t) {
    return e.importFileGuid === t.importFileGuid && e.matchedFieldGuidSet.has(t.fieldGuid);
  }),
      l = i && t.some(function (t) {
    return "" === t.fieldGuid && e.importFileGuid === t.importFileGuid;
  });
  e.Matched = !i, e.Removed = l, e.Selected = !o && !i && e.matchedFieldGuidSet.has(r);
},
    calculateAcreage = function calculateAcreage(e) {
  if (!e) return 0;
  var t = L.simplify(e.geometry);
  t && t.rings || (t = e.geometry);
  var r = w.geodesicAreas([t.spatialReference.isGeographic ? t : f.webMercatorToGeographic(t)], "acres");
  return Number(Math.abs(r[0]).toFixed(2));
},
    createUniqueValueRenderer = function createUniqueValueRenderer(e) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return new C({
    field: e,
    defaultSymbol: l.fromJSON(o.createSimpleFillSymbolJSON([191, 209, 245, 255])),
    uniqueValueInfos: t.map(function (e) {
      var t = [Number(e.color.r), Number(e.color.g), Number(e.color.b), 255];
      return {
        symbol: l.fromJSON(o.createSimpleFillSymbolJSON(t, t, .4)),
        value: e.classId
      };
    })
  });
},
    getLabelLineGraphics = function getLabelLineGraphics(e, t) {
  var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : E.symbols.fields.labels;
  var o = arguments.length > 3 ? arguments[3] : undefined;
  var i = arguments.length > 4 ? arguments[4] : undefined;
  var a = r.lineHeight,
      s = r.text,
      n = o ? _defineProperty({}, o, i) : null;
  var m = a / 2 * t.length;
  return t.map(function (t) {
    var r = JSON.parse(JSON.stringify(s));
    r.text = t, r.xoffset = 0, r.yoffset = m, m -= a;
    var o = l.fromJSON(r);
    return M.create({
      geometry: e,
      symbol: o,
      attributes: n
    });
  });
},
    scaleSymbol = function scaleSymbol(e, t) {
  if ("simple-marker" === e.type) e.size = e.size * t;else if ("simple-line" === e.type) e.width = e.width * t;else if ("text" === e.type) {
    var _r = e;
    _r.font.size = _r.font.size * t, _r.xoffset = _r.xoffset * t, _r.yoffset = _r.yoffset * t;
  }
  "simple-fill" !== e.type && "picture-fill" !== e.type || null == e.outline || scaleSymbol(e.outline, t);
};

var createLabelClass = function createLabelClass(e, t) {
  var r = F.fromJSON(E.symbols.sampleSites.label.value);
  return r.symbol = l.fromJSON(e || E.symbols.sampleSites.label.text), r.labelExpressionInfo = o.createLabelValueExpression(t), r;
},
    T = _objectSpread({}, p),
    checkExpression = function checkExpression(e) {
  return "IIF(Text($feature.".concat(T.sampleID, ") == '', '', ").concat(e, ")");
},
    P = checkExpression("$feature.".concat(T.sampleID, " + ' - ' + $feature.").concat(T.sequenceID)),
    v = checkExpression("$feature.".concat(T.sampleID)),
    D = "$feature.".concat(T.value),
    U = {
  addGraphic: function addGraphic(e, t) {
    return e.add(t);
  },
  removeGraphic: function removeGraphic(e, t) {
    return e.remove(t);
  },
  create: function create(e, r) {
    if ("string" != typeof e) return new g(r);

    switch (e) {
      case t.FeatureLayer:
        return new h(r);

      case t.GraphicsLayer:
        return new g(r);

      case t.MapImageLayer:
        return new O(r);

      case t.VectorTileLayer:
        return new N(r);

      case t.TileLayer:
        return new x(r);

      default:
        throw new Error("Unsupported layer type: ".concat(e));
    }
  },
  createFeatureCollection: a,
  createFeatureLayerDefinition: s,
  calculateAcreage: calculateAcreage,
  createUniqueValueRenderer: createUniqueValueRenderer,
  getCentroidLatLong: function getCentroidLatLong(e) {
    if (!e) return null;
    var t = L.simplify(e.geometry);
    t && t.rings || (t = e.geometry);
    var r = t.centroid;
    return {
      lat: r.latitude,
      long: r.longitude
    };
  },
  getCustomerFieldBoundaries: function getCustomerFieldBoundaries(e, t, r) {
    return S([e], r, null, !0).then(function (e) {
      return t ? e.filter(function (e) {
        return e.fieldGuid !== t;
      }) : e;
    });
  },
  getFieldLabelGraphic: function getFieldLabelGraphic(t, r) {
    var o = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : E.symbols.fields.labels;
    var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "";
    var l = t.geometry,
        a = t.attributes,
        s = o.placementPrecision,
        m = l.type === e.point ? l : n.getPolyLabelPoint(l, s);
    return getLabelLineGraphics(m, r, o, i, a[i]);
  },
  getLabelLineGraphics: getLabelLineGraphics,
  getSingleLineLabelGraphic: function getSingleLineLabelGraphic(t, r) {
    var o = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : E.symbols.fields.labels;
    var i = t.geometry,
        a = o.placementPrecision,
        s = o.text,
        m = i.type === e.point ? i : n.getPolyLabelPoint(i, a),
        c = JSON.parse(JSON.stringify(s));
    c.text = r;
    var p = l.fromJSON(c);
    return M.create({
      geometry: m,
      symbol: p
    });
  },
  identifyLargestPolygonParts: function identifyLargestPolygonParts(e, t, r, o) {
    var i = new Map();

    var _iterator = _createForOfIteratorHelper(e),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _l2 = _step.value;

        var _e2 = _l2.attributes[t].toLowerCase();

        if (i.has(_e2)) {
          var _t = i.get(_e2).find(function (e) {
            return 1 === e.attributes[r];
          });

          calculateAcreage(_l2) > calculateAcreage(_t) ? (_t.attributes[r] = 0, _l2.attributes[r] = 1) : _l2.attributes[r] = 0;
        } else _l2.attributes[r] = 1, i.set(_e2, []);

        i.get(_e2).push(_l2);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    if (o) {
      var _iterator2 = _createForOfIteratorHelper(i),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _step2$value = _slicedToArray(_step2.value, 2),
              _l = _step2$value[0],
              _a = _step2$value[1];

          i.set(_l, _a.filter(function (e) {
            return 1 === e.attributes[r];
          }));
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }

    return i;
  },
  isOverlappingLabels: function isOverlappingLabels(e, t, r, o) {
    if (0 === r.length) return !1;
    var i = r.map(function (t) {
      return _getLabelScreenExtent(e, t, o);
    });
    return t.some(function (t) {
      var r = _getLabelScreenExtent(e, t, o);

      return i.some(function (e) {
        return e.intersects(r);
      });
    });
  },
  scaleRendererSymbology: function scaleRendererSymbology(e, t) {
    if ("simple" === e.toJSON().type) scaleSymbol(e.symbol, t);else if (e instanceof C) {
      var _iterator3 = _createForOfIteratorHelper(e.uniqueValueInfos),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var _r2 = _step3.value;
          scaleSymbol(_r2.symbol, t);
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    }
  },
  scaleSymbol: scaleSymbol,
  zoomToFeatures: function zoomToFeatures(e, t) {
    var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
    if (0 === t.length) return void console.warn("cannot zoom to empty feature set");
    var o = "geometry" in t[0] && null != t[0].geometry ? t.map(function (e) {
      return e.geometry;
    }) : t;
    return e.extent = 1 !== r ? L.union(o).extent.expand(r) : L.union(o).extent, e.extent;
  },
  createSampleIdLabelClass: function createSampleIdLabelClass() {
    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    return createLabelClass(e, v);
  },
  createSequenceIdLabelClass: function createSequenceIdLabelClass() {
    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    return createLabelClass(e, P);
  },
  createValueLabelClass: function createValueLabelClass() {
    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    return createLabelClass(e, D);
  }
},
    k = {
  getFieldCentroids: function getFieldCentroids(e) {
    return d(e).then(function (e) {
      var t = e.fieldExtent,
          r = e.fieldCentroids;
      return {
        extent: t ? f.geographicToWebMercator(new J({
          xmin: t.minX,
          ymin: t.minY,
          xmax: t.maxX,
          ymax: t.maxY,
          spatialReference: {
            wkid: 4326
          }
        })) : null,
        data: r.map(function (e) {
          var _f$lngLatToXY = f.lngLatToXY(parseFloat(e.x), parseFloat(e.y)),
              _f$lngLatToXY2 = _slicedToArray(_f$lngLatToXY, 2),
              t = _f$lngLatToXY2[0],
              r = _f$lngLatToXY2[1];

          return {
            geometry: {
              x: t,
              y: r
            },
            attributes: {
              customerGuid: e.customerGuid,
              fieldGuid: e.fieldGuid,
              filtered: !1,
              selected: !1
            }
          };
        }),
        rendererOptions: {
          size: 7,
          styles: [{
            break: !0,
            calc: function calc(e) {
              return !e.attributes.filtered && !e.attributes.selected;
            },
            calcFunc: "return !feat.attributes.filtered && !feat.attributes.selected",
            fillStyle: _getRgbaFromColorArray(E.symbols.fields.normal.outline.color, !1),
            color: _getColorArray(E.symbols.fields.normal.outline.color, !1),
            styleName: "active"
          }, {
            break: !0,
            calc: function calc(e) {
              return e.attributes.selected;
            },
            calcFunc: "return feat.attributes.selected",
            fillStyle: _getRgbaFromColorArray(E.symbols.fields.selected.color),
            color: _getColorArray(E.symbols.fields.selected.color),
            styleName: "selected"
          }, {
            break: !0,
            calc: function calc(e) {
              return e.attributes.filtered;
            },
            calcFunc: "return feat.attributes.filtered",
            fillStyle: _getRgbaFromColorArray(E.symbols.fields.filteredOut.color, !1),
            color: _getColorArray(E.symbols.fields.filteredOut.color, !1),
            styleName: "filteredOut"
          }]
        }
      };
    });
  },
  getFilterPointData: function getFilterPointData(e) {
    return u(e.agEventGeneralGuid).then(function (e) {
      return JSON.parse(e);
    }).then(function (t) {
      return {
        data: t.records.map(function (r) {
          var o = r.filters.map(function (e) {
            return t.filters[e];
          }),
              _f$lngLatToXY3 = f.lngLatToXY(r.x, r.y),
              _f$lngLatToXY4 = _slicedToArray(_f$lngLatToXY3, 2),
              i = _f$lngLatToXY4[0],
              l = _f$lngLatToXY4[1],
              a = {
            x: i,
            y: l
          },
              s = {
            matchedFilterSet: new Set(o)
          };

          return _updateFilterPointAttributes(s, e.filters), {
            geometry: a,
            attributes: s
          };
        }),
        rendererOptions: {
          size: E.symbols.filterDataPoints.size,
          styles: [{
            break: !0,
            calcFunc: "return feat.attributes.Filtered",
            color: _getColorArray(E.symbols.filterDataPoints.filteredColor),
            styleName: "filtered"
          }, {
            break: !0,
            calcFunc: "return !feat.attributes.Filtered",
            color: _getColorArray(E.symbols.filterDataPoints.unfilteredColor),
            styleName: "unfiltered"
          }]
        }
      };
    });
  },
  getImportPointData: function getImportPointData(e, t) {
    var r = t.importFileGuidList,
        o = t.filteredFieldImportFileList,
        i = t.selectedMatchedFieldGuid,
        l = t.ignoreSelectedField;
    return y(e, r).then(function (e) {
      return JSON.parse(e);
    }).then(function (e) {
      return {
        data: e.reduce(function (e, t) {
          var r = {};
          Object.keys(t.fields).forEach(function (e) {
            return r[e] = b(t.fields[e]);
          });
          var a = b(t.import_file_guid);
          return t.records.map(function (e) {
            var r = e.fields.map(function (e) {
              return t.fields[e];
            });
            console.assert(!r.some(function (e) {
              return "" === e;
            }));

            var _f$lngLatToXY5 = f.lngLatToXY(e.x, e.y),
                _f$lngLatToXY6 = _slicedToArray(_f$lngLatToXY5, 2),
                s = _f$lngLatToXY6[0],
                n = _f$lngLatToXY6[1],
                m = {
              x: s,
              y: n
            },
                c = {
              importFileGuid: a,
              matchedFieldGuidSet: new Set(r)
            };

            return _updatePointDataAttributes(c, o, i, l), {
              geometry: m,
              attributes: c
            };
          }).forEach(function (t) {
            e.push(t);
          }), e;
        }, []),
        rendererOptions: {
          size: E.symbols.importDataPoints.size,
          styles: [{
            break: !0,
            calcFunc: "return feat.attributes.Matched && !feat.attributes.Selected && !feat.attributes.Removed",
            color: _getColorArray(E.symbols.importDataPoints.matchedColor),
            styleName: "matched"
          }, {
            break: !0,
            calcFunc: "return !feat.attributes.Matched && !feat.attributes.Selected && !feat.attributes.Removed",
            color: _getColorArray(E.symbols.importDataPoints.unmatchedColor),
            styleName: "unmatched"
          }, {
            break: !0,
            calcFunc: "return feat.attributes.Removed",
            color: _getColorArray(E.symbols.importDataPoints.removedColor, !1),
            styleName: "removed"
          }, {
            break: !0,
            calcFunc: "return feat.attributes.Selected",
            color: _getColorArray(E.symbols.importDataPoints.selectedColor),
            styleName: "selected"
          }]
        }
      };
    });
  },
  updateFieldCentroids: function updateFieldCentroids(e, t, r) {
    if (!e) return void console.warn("Unable to update Field Centroids at this time. Canvas Layer not loaded yet.");
    var o = e.getData();

    for (var _i = 0; _i < o.length; _i++) {
      var _e3 = o[_i].attributes;
      _e3.filtered = !t.has(_e3.fieldGuid), _e3.selected = r.has(_e3.fieldGuid);
    }

    e.setData(o);
  },
  updateFilterPointData: function updateFilterPointData(e, t) {
    var r = t.filters;
    return new Promise(function (t) {
      return setImmediate(function () {
        var o = e.data,
            i = o.length;
        var l = 0;

        for (; l < i;) {
          _updateFilterPointAttributes(o[l].attributes, r), l++;
        }

        e.data = o, e.length = o.length, e.filters = r, t();
      });
    });
  },
  updateImportPointData: function updateImportPointData(e, t) {
    var r = t.filteredFieldImportFileList,
        o = t.selectedMatchedFieldGuid,
        i = t.ignoreSelectedField;
    return new Promise(function (l) {
      return setImmediate(function () {
        var a = e.data,
            s = a.length;
        var n = 0;

        for (; n < s;) {
          _updatePointDataAttributes(a[n].attributes, r, o, i), n++;
        }

        e.data = a, e.length = a.length, e.importData = t, l();
      });
    });
  }
};

var esriUnits = function esriUnits() {
  _classCallCheck(this, esriUnits);
};

esriUnits.ACRES = "acres", esriUnits.ARES = "ares", esriUnits.CENTIMETERS = "centimeters", esriUnits.DECIMAL_DEGREES = "decimalDegrees", esriUnits.DECIMETERS = "decimeters", esriUnits.DEGREE_MINUTE_SECONDS = "degreeMinuteSeconds", esriUnits.FEET = "feet", esriUnits.INCHES = "inches", esriUnits.KILOMETERS = "kilometers", esriUnits.METERS = "meters", esriUnits.MILES = "miles", esriUnits.POINTS = "points", esriUnits.SQUARE_FEET = "square feet", esriUnits.SQUARE_MILES = "squareMiles", esriUnits.YARDS = "yards";

var setUpLayerRenderCompleteHandler = function setUpLayerRenderCompleteHandler(e, t) {
  var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
  return new Promise(function (o, i) {
    e.whenLayerView(t).then(function (e) {
      var t = 0;
      var i = e.watch("updating", function (e) {
        e || (t++, (!r || r && 2 === t) && (o(!0), i && i.remove()));
      });
    }).catch(function (e) {
      i(e);
    });
  });
},
    I = Object.freeze({
  __proto__: null,
  esriUnits: esriUnits,
  disableZooming: function disableZooming(e) {
    function stopEvtPropagation(e) {
      e.stopPropagation();
    }

    return e.popup.dockEnabled = !0, e.popup.actions.removeAll(), e.ui.remove("zoom"), e.on("mouse-wheel", stopEvtPropagation), e.on("double-click", stopEvtPropagation), e.on("double-click", ["Control"], stopEvtPropagation), e.on("drag", stopEvtPropagation), e.on("drag", ["Shift"], stopEvtPropagation), e.on("drag", ["Shift", "Control"], stopEvtPropagation), e.on("pointer-up", function (e) {
      console.warn("pointer-up event");
    }), e.on("pointer-up", ["Shift"], function (e) {
      console.warn(" SHIFT pointer-up event");
    }), e.on("pointer-up", ["Shift", "Control"], function (e) {
      console.warn("SHIFT+CONTROL pointer-up event");
    }), e.on("key-down", function (e) {
      var t = e.key;
      -1 !== ["+", "-", "Shift", "_", "="].indexOf(t) && e.stopPropagation();
    }), e;
  },
  setUpLayerRenderCompleteHandler: setUpLayerRenderCompleteHandler,
  setUpLayerRenderCompleteOnVisibleHandler: function setUpLayerRenderCompleteOnVisibleHandler(e, t) {
    return new Promise(function (r, o) {
      e.whenLayerView(t).then(function (e) {
        var t = e.watch("updating", function (o) {
          !o && e.visible && (r(!0), t && t.remove());
        });
      }).catch(function (e) {
        o(e);
      });
    });
  }
});

export { k as C, M as G, U as L, E as M, createUniqueValueRenderer as c, esriUnits as e, I as m, setUpLayerRenderCompleteHandler as s };